import { create } from "zustand"
import { DrawerState } from "./types"
import { drawerWidth } from "src/lib/consts/drawerWidth"

const useDrawerStore = create<DrawerState>((set: any, get: any) => ({
	open: false,
	isFullscreen: false,
	width: drawerWidth,
	isResizing: false,
	setOpen: (value: boolean) => set({ open: value }),
	setFullscreen: (value: boolean) => set({ isFullscreen: value }),
	setWidth: (value: number) => set({ width: value }),
	setResizing: (value: boolean) => set({ isResizing: value }),
	toggle: () => set({ open: !get().open }),
	toggleFullscreen: () => set({ isFullscreen: !get().isFullscreen }),
	openDrawer: () => set({ open: true }),
	closeDrawer: () => set({ open: false, isFullscreen: false }),
}))

export { useDrawerStore }
